import { render, staticRenderFns } from "./OpportunityView.vue?vue&type=template&id=c8ab84aa"
import script from "./OpportunityView.vue?vue&type=script&lang=js"
export * from "./OpportunityView.vue?vue&type=script&lang=js"
import style0 from "./OpportunityView.vue?vue&type=style&index=0&id=c8ab84aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports